import React from 'react'
import AppTextLogoSvg from '../appConfigs/svgs/AppTextLogoSvg'

const Loading = () => {
  return (
    <div>
      <AppTextLogoSvg size={16} />
    </div>
  )
}
export default Loading
